import * as React from "react";
import Button from "@mui/material/Button";
import { Dialog as MuiDialog } from "@mui/material";
import NoScrollDialog from "components/NoScrollDialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import LoadingButton from "components/LoadingButton";
import MDButton from "components/MDButton";
import { useLanguage } from "contexts/language.context";

export default function AlertDialog({
  open,
  setOpen,
  title,
  content,
  onOk,
  onCancel,
  danger,
  okContent,
  useNoScrollDialog = true,
  disableScrollLock = true,
}) {
  const { label } = useLanguage();
  //const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(Math.random());
  };

  React.useEffect(() => {
    setLoading(false);
  }, [open]);

  const handleClose = () => {
    setOpen(false);
  };

  const [loading, setLoading] = React.useState(false);
  const Dialog = useNoScrollDialog ? NoScrollDialog : MuiDialog;

  return (
    <React.Fragment>
      {/*<Button variant="outlined" onClick={handleClickOpen}>
        Open alert dialog
  </Button>*/}
      <Dialog
        open={open ? true : false}
        onClose={handleClose}
        {...(!useNoScrollDialog ? { disableScrollLock } : {})}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id={"alert-dialog-title: " + title}>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {content}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              if (onCancel) onCancel();
              handleClose();
            }}
          >
            {label("cancel-button")}
          </MDButton>
          <LoadingButton
            loading={loading}
            onClick={async () => {
              setLoading(true);
              if (onOk) await onOk();
              setLoading(false);
              handleClose();
            }}
            color={danger ? "error" : "info"}
            variant="gradient"
            autoFocus
          >
            {okContent || label("ok")}
          </LoadingButton>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}
